import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule, } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { InvoicesComponent } from './invoices.component';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { PaymentProcessComponent } from './payments/payment-process/payment-process.component';
import { CheckoutComponent } from './payments/checkout/checkout.component';
import { SpeedpayPaymentComponent } from './payments/speedpay-payment/speedpay-payment.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SpeedframeComponent } from './payments/speedframe/speedframe.component';
import { InvoicesListComponent } from './invoices-list/invoices-list.component';
import { SpinnerInterceptor } from '../services/spinner.interceptor';
import { NgxSpinnerModule } from 'ngx-spinner';
import { InvoiceDetailsComponent } from './invoice-details/invoice-details.component';
import { TSAInvoiceDetailsComponent } from './tsa-invoice-details/tsa-invoice-details.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { GlobalModule } from '../shared/global.module';
import { DisputeComponent } from '../dispute/dispute.component';
import { MydisputeComponent } from '../dispute/mydispute/mydispute.component';
import { DisputeDetailsComponent } from '../dispute/dispute-details/dispute-details.component';
import { PaymentMethodsComponent } from '../setting/payment-methods/payment-methods.component';
import { AuthenticationService } from '../auth/authentication.service';
import { UsageRecordComponent } from '../usage-record/usage-record.component';
import { BQUsageRecordComponent } from '../bq-usage-record/bq-usage-record.component';
import { SessionStorageService } from '../services/session-storage.service';
import { SettingComponent } from '../setting/setting.component';
import { RecurringComponent } from '../setting/recurring/recurring.component';
import { BansDropdownComponent } from '../shared/bans-dropdown/bans-dropdown.component';
import { ProcessRecurringComponent } from '../setting/process-recurring/process-recurring.component';
import { ManagePaymentMethodsComponent } from '../shared/payment-flow-container/manage-payment-methods/manage-payment-methods.component';
import { AddEditPaymentMethodComponent } from '../shared/payment-flow-container/manage-payment-methods/add-edit-payment-method/add-edit-payment-method.component';
import { DropdownComponent } from '../shared/dropdown/dropdown.component';
import { Card } from '../shared/payment-flow-container/manage-payment-methods/add-edit-payment-method/card/card.component';
import { Bank } from '../shared/payment-flow-container/manage-payment-methods/add-edit-payment-method/bank/bank.component';
import { PaymentFlowComponent } from '../shared/payment-flow-container/payment-flow.component';
import { ConfirmPaymentComponent } from '../shared/payment-flow-container/confirm-payment/confirm-payment.component';
import { BillAnalystComponent } from '../bill-analyst/bill-analyst.component';
import { PaymentHistoryComponent } from '../payment-history/payment-history.component';
import { HistoricalDataComponent } from '../historical-data/historical-data.component';
import { HistoricalInvoiceComponent } from '../historical-data/historical-invoices/historical-invoices.component';
import { HistoricalPaymentsHistoryComponent } from '../historical-data/historical-payment-history/historical-payment-history.component';
import { HistoricalInvoiceDetailComponent } from '../historical-data/historical-invoice-detail/historical-invoice-detail.component';
import { ReusableErrorComponent } from '../shared/popup/reusable-error-component/reusable-error.component';
import { InvoiceSummaryComponent } from './invoice-summary/invoice-summary.component';
import { PaymentMethodService } from '../services/payment-method.service';
import { PaperlessBillingComponent } from '../setting/paperless-billing/paperless-billing.component';
import { CreateDisputeComponent } from '../dispute/create-dispute/create-dispute.component';
import { CreateDisputeInvoiceInfoComponent } from '../dispute/create-dispute/create-dispute-invoice-info/create-dispute-invoice-info.component';
import { CreateDisputeSummaryComponent } from '../dispute/create-dispute/create-dispute-summary/create-dispute-summary.component';
import { HistoricalPaySummaryComponent } from '../historical-data/historical-pay-summary/historical-pay-summary.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}


export const INVOICSES_ROUTES: Routes = [
  {
    path: 'invoices',
    component: InvoicesComponent,
    children: [
      {
        path: '',
        component: InvoicesListComponent,
      },
      {
        path: 'summary',
        component: InvoiceSummaryComponent
      },
      {
        path: 'checkout',
        component: CheckoutComponent,
      },
      {
        path: 'create-dispute',
        component: CreateDisputeComponent,
        children: [
          {
            path: 'invoice-info',
            component: CreateDisputeInvoiceInfoComponent
          },
          {
            path: 'dispute-summary',
            component: CreateDisputeSummaryComponent
          },
          {
            path: '',
            redirectTo: 'invoice-info',
            pathMatch: 'full'
          }
        ]
      },
      {
        path: 'dispute',
        component: DisputeComponent
      },
      {
        path: 'view-my-dispute',
        component: MydisputeComponent,
      },
      {
        path: 'view-my-dispute/:id',
        component: DisputeDetailsComponent,
      },
      {
        path: 'payment-history',
        component: PaymentHistoryComponent
      },
      {
        path: 'payment-methods',
        component: PaymentMethodsComponent
      },
      {
        path: 'paperless-billing',
        component: PaperlessBillingComponent
      },
      {
        path: 'usage-records',
        component: BQUsageRecordComponent
      },
      {
        path: 'payment-processing',
        component: PaymentProcessComponent
      },
      {
        path: 'speedframe',
        component: SpeedframeComponent,
        pathMatch: 'full'
      },
      {
        path: 'setting',
        component: SettingComponent,
        children: [
          {
            path: 'paymentMethods',
            component: PaymentMethodsComponent
          },
          {
            path: 'autopay',
            component: RecurringComponent
          },
          {
            path: '',
            redirectTo: 'autopay',
            pathMatch: 'full'
          },
          {
            path: 'paperlessBilling',
            component: PaperlessBillingComponent
          }
        ]
      },
      {
        path: 'process-recurring',
        component: ProcessRecurringComponent
      },
      {
        path: 'bill-analytics',
        component: BillAnalystComponent
      },
      {
        path: 'view-invoice/:id',
        component: InvoiceDetailsComponent
      },
      {
        path: 'view-tsa-invoice/:id',
        component: TSAInvoiceDetailsComponent
      },
      {
        path: 'historical-data',
        component: HistoricalDataComponent,
        children: [
          {
            path: '',
            redirectTo: 'historical-invoices',
            pathMatch: 'full'
          },
          {
            path: 'summary',
            component: HistoricalPaySummaryComponent
          },
          {
            path: 'checkout',
            component: CheckoutComponent
          },
          {
            path: 'historical-invoices',
            component: HistoricalInvoiceComponent
          },
          {
            path: 'historical-payments',
            component: HistoricalPaymentsHistoryComponent
          },
          {
            path: ':id',
            component: HistoricalInvoiceDetailComponent
          }
        ]
      }
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(INVOICSES_ROUTES),
    BrowserModule,
    NgxSpinnerModule,
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    InfiniteScrollModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    GlobalModule
  ],
  declarations: [
    InvoicesComponent,
    CheckoutComponent,
    SpeedpayPaymentComponent,
    PaymentProcessComponent,
    SpeedframeComponent,
    InvoicesListComponent,
    InvoiceDetailsComponent,
    TSAInvoiceDetailsComponent,
    CreateDisputeComponent,
    CreateDisputeInvoiceInfoComponent,
    CreateDisputeSummaryComponent,
    DisputeComponent,
    MydisputeComponent,
    DisputeDetailsComponent,
    PaymentMethodsComponent,
    PaperlessBillingComponent,
    UsageRecordComponent,
    BQUsageRecordComponent,
    RecurringComponent,
    SettingComponent,
    BansDropdownComponent,
    ProcessRecurringComponent,
    PaymentFlowComponent,
    ConfirmPaymentComponent,
    ManagePaymentMethodsComponent,
    AddEditPaymentMethodComponent,
    Bank,
    Card,
    DropdownComponent,
    BillAnalystComponent,
    PaymentHistoryComponent,
    HistoricalDataComponent,
    HistoricalInvoiceComponent,
    HistoricalPaymentsHistoryComponent,
    HistoricalInvoiceDetailComponent,
    InvoiceSummaryComponent,
    ReusableErrorComponent
  ],
  exports: [
    RouterModule,
    BrowserModule,
    NgxSpinnerModule,
    CommonModule,
    HttpClientModule,
    FormsModule,
    NgbModule,
    InfiniteScrollModule,
    TranslateModule,
    GlobalModule
  ],
  providers: [
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true,

    },
    SessionStorageService,
    PaymentMethodService
  ],
  bootstrap: [InvoicesComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class InvoicesModule { }
